/*
export const someGetter = (state) => {}
 */
import { date } from 'quasar'

export default {
  documentList
}

function documentList (state, getters, rootState) {
  return state.list.map(document => {
    document.DATE_CREATED = (document.DATE_CREATED) ? date.formatDate(document.DATE_CREATED, rootState.shared.formats.date) : null
    return document
  })
}
